import { render } from "./FTLIntracity.vue?vue&type=template&id=15273906&scoped=true&ts=true"
import script from "./FTLIntracity.vue?vue&type=script&lang=ts"
export * from "./FTLIntracity.vue?vue&type=script&lang=ts"

import "./FTLIntracity.vue?vue&type=style&index=0&id=15273906&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15273906"]])

export default __exports__